/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { IndexDependencies } from './dependenciesIndexClass.generated';
import { compareNaturalDependencies } from './dependenciesCompareNatural.generated';
import { sizeDependencies } from './dependenciesSize.generated';
import { subsetDependencies } from './dependenciesSubset.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSetIntersect } from '../../factoriesAny.js';
export var setIntersectDependencies = {
  DenseMatrixDependencies: DenseMatrixDependencies,
  IndexDependencies: IndexDependencies,
  compareNaturalDependencies: compareNaturalDependencies,
  sizeDependencies: sizeDependencies,
  subsetDependencies: subsetDependencies,
  typedDependencies: typedDependencies,
  createSetIntersect: createSetIntersect
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSetIntersect.generated.js
// module id = 520
// module chunks = 0